module.exports = __webpack_public_path__ + "static/3-formation-deformation-s-a3-f314c756d1d9aa90b722e124d9d3be55.jpg";